import React from 'react';
import { CustomCreateableSelectTemplate } from 'themes/components';

function CustomCreateableSelect(props) {
	return <CustomCreateableSelectTemplate {...props} />;
}

export default CustomCreateableSelect;
